import { render, staticRenderFns } from "./editEitaa.vue?vue&type=template&id=06658b8d&scoped=true"
import script from "./editEitaa.vue?vue&type=script&lang=js"
export * from "./editEitaa.vue?vue&type=script&lang=js"
import style0 from "./editEitaa.vue?vue&type=style&index=0&id=06658b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06658b8d",
  null
  
)

export default component.exports